import React from 'react';
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import Layout from "@/Shared/Layout";
import LoadingButton from "@/Shared/LoadingButton";
import CouponForm from "@/Pages/Coupons/Assets/CouponForm";

const Edit = () => {
  const {coupon, merchants} = usePage().props

  const {data, setData, errors, put, processing} = useForm({
    code: coupon.code || '',
    description: coupon.description || '',
    link: coupon.link || '',
    restrictions: coupon.restrictions || '',
    start_date: coupon.start_date || null,
    expire_date: coupon.expire_date || null,
    source: coupon.source || '',
    ysnTested: coupon.ysnTested || 0,
    ysnWorking: coupon.ysnWorking || 0,
    ysnDeleted: coupon.ysnDeleted || 0,
    internal_notes: coupon.internal_notes || '',
    merchant_id: coupon.merchant_id || ''
  });

  function handleSubmit(e) {
    e.preventDefault();
    put(route('added.coupons.update', coupon.id).url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('added.coupons')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Added Coupons
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Edit
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <CouponForm errors={errors} data={data} setData={setData} merchants={merchants}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit Coupon
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit coupon" children={page} />;

export default Edit;
